import Vue from 'vue';
import '@/assets/stylesheets/v2/_close-btn.scss';
/**
 * Base Component for Close Button
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since v0.1.6
 */
export default Vue.extend({
    render(createElement) {
        return createElement('v-btn', {
            props: {
                icon: true,
            },
            class: 'close-btn',
            on: {
                click: () => {
                    this.$emit('onClose');
                },
            },
        }, [createElement('v-icon', 'close')]);
    },
});
